// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ToolsAround_toolAround__7zO4q {
    width: 40px;
    height: 40px;
    border: 1px solid #8a8686;
    z-index: 3;
    border-radius: 50%;
    background-color: rgba(0, 0, 0, 0.51);
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;

}
.ToolsAround_toolAround__7zO4q i{
    font-size: 20px;
    color:white;
}`, "",{"version":3,"sources":["webpack://./src/components/UI/ToolsAround/ToolsAround.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,UAAU;IACV,kBAAkB;IAClB,qCAAqC;IACrC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;;AAEnB;AACA;IACI,eAAe;IACf,WAAW;AACf","sourcesContent":[".toolAround {\n    width: 40px;\n    height: 40px;\n    border: 1px solid #8a8686;\n    z-index: 3;\n    border-radius: 50%;\n    background-color: rgba(0, 0, 0, 0.51);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    cursor: pointer;\n\n}\n.toolAround i{\n    font-size: 20px;\n    color:white;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"toolAround": `ToolsAround_toolAround__7zO4q`
};
export default ___CSS_LOADER_EXPORT___;
